import mergeClassNames from "common/mergeClassNames";
import React from "react";

interface SidePanelProps {
    className?: string;
    children?: React.ReactNode;
    rounded?: boolean;
}

export default function SidePanel({ className, children, rounded = true }: SidePanelProps) {
    return (
        <div className={mergeClassNames("relative flex h-full w-[400px] flex-none flex-col overflow-auto border border-gray-200", rounded ? "rounded-md" : "", className)}>
            {children}
        </div>
    );
}
